// HOME TYPES
export const HOME_ANIMATE = 'HOME_ANIMATE';
export const SET_HOME_SHOW_VIDEO = 'SET_HOME_SHOW_VIDEO';

// MENU TYPES
export const SET_MENU_OPEN = 'SET_MENU_OPEN';
export const SET_MENU_HIDE = 'SET_MENU_HIDE';

// ABOUT TYPES
export const GET_ABOUT = 'GET_ABOUT';
export const INPUT_ABOUT = 'INPUT_ABOUT';

// PHOTOS TYPES
export const GET_PHOTOS = 'GET_PHOTOS';
export const SET_PHOTOS = 'SET_PHOTOS';

// PACKAGE TYPES
export const GET_PLACES = 'GET_PLACES';
export const SET_PLACES = 'SET_PLACES';
export const SET_PACKAGE = 'SET_PACKAGE';
export const SET_GENEROS = 'SET_GENEROS';
export const GET_GENEROS = 'GET_GENEROS';
export const GET_SERVICES = 'GET_SERVICES';
export const SET_SERVICES = 'SET_SERVICES';
export const GET_PACKAGE = 'GET_PACKAGE';
export const SAVE_PACKAGE = 'SAVE_PACKAGE';
export const SET_LOCALFORAGE_LOADED = 'SET_LOCALFORAGE_LOADED';

// VIDEOS TYPES
export const GET_VIDEOS = 'GET_VIDEOS';
export const SET_VIDEOS = 'SET_VIDEOS';
export const SET_VIDEOS_PROM = 'SET_VIDEOS_PROM';
export const GET_VIDEOS_PROM = 'GET_VIDEOS_PROM';
export const SET_VIDEOS_TESTI = 'SET_VIDEOS_TESTI';
export const GET_VIDEOS_TESTI = 'GET_VIDEOS_TESTI';
export const SET_HOME_VIDEO = 'SET_HOME_VIDEO';
export const GET_HOME_VIDEO = 'GET_HOME_VIDEO';

// CONTACT TYPES (Original fields)
export const INPUT_CONTACT_NAME = 'INPUT_CONTACT_NAME';
export const INPUT_CONTACT_EMAIL = 'INPUT_CONTACT_EMAIL';
export const INPUT_CONTACT_MSG = 'INPUT_CONTACT_MSG';
export const SEND_CONTACT = 'SEND_CONTACT';
export const SET_CONTACT_DB = 'SET_CONTACT_DB';
export const GET_CONTACT_DB = 'GET_CONTACT_DB';
export const SET_CONTACT_STATUS = 'SET_CONTACT_STATUS';
// NEW FIELDS
export const INPUT_CONTACT_SCHOOL_NAME = 'INPUT_CONTACT_SCHOOL_NAME';
export const INPUT_CONTACT_CLASS_NAME = 'INPUT_CONTACT_CLASS_NAME';
export const INPUT_CONTACT_COMMITTEE_PRESIDENT = 'INPUT_CONTACT_COMMITTEE_PRESIDENT';
export const INPUT_CONTACT_COMMITTEE_PHONE = 'INPUT_CONTACT_COMMITTEE_PHONE';
export const INPUT_CONTACT_COMMITTEE_EMAIL = 'INPUT_CONTACT_COMMITTEE_EMAIL';
export const INPUT_CONTACT_CLASS_PRESIDENT = 'INPUT_CONTACT_CLASS_PRESIDENT';
export const INPUT_CONTACT_CLASS_PHONE = 'INPUT_CONTACT_CLASS_PHONE';
export const INPUT_CONTACT_CLASS_EMAIL = 'INPUT_CONTACT_CLASS_EMAIL';
export const INPUT_CONTACT_DATE_PROM = 'INPUT_CONTATCT_DATE_PROM';
export const INPUT_CONTACT_GUESTS_NUM = 'INPUT_CONTACT_GUESTS_NUM';
// NEW REGULAR FIELDS
export const INPUT_CONTACT_PHONE = 'INPUT_CONTACT_PHONE';
export const INPUT_CONTACT_DATE_EVENT = 'INPUT_CONTACT_DATE_EVENT';
export const INPUT_CONTACT_TYPE_EVENT = 'INPUT_CONTACT_TYPE_EVENT';

// ESTIMATE TYPES (Otriginal fields)
export const INPUT_ESTIMATE_NAME = 'INPUT_ESTIMATE_NAME';
export const INPUT_ESTIMATE_EMAIL = 'INPUT_ESTIMATE_EMAIL';
export const INPUT_ESTIMATE_MSG = 'INPUT_ESTIMATE_MSG';
export const SEND_ESTIMATE = 'SEND_ESTIMATE';
export const SET_ESTIMATE_STATUS = 'SET_ESTIMATE_STATUS';
// NEW FIELDS
export const INPUT_ESTIMATE_PHONE = 'INPUT_ESTIMATE_PHONE';
export const INPUT_ESTIMATE_DATE_EVENT = 'INPUT_ESTIMATE_DATE_EVENT';
export const INPUT_ESTIMATE_TYPE_EVENT = 'INPUT_ESTIMATE_TYPE_EVENT';


// WEBPACK FOOTER //
// ./src/actions/Types.js